// klonovač částí formuláře //

// dialog pro potvrzovací callback:
const HEAD = 'Odebrání sekce formuláře';
const DIALOG = 'Zadané hodnoty budou při odebrání sekce smazány. Skutečně chcete odebrat sekci?';
// selector - inputy
const INPUT = 'input:not([type="radio"], [type="checkbox"], [type="hidden"]), textarea';
// selector - checkboxy, radia
const CHK = 'input[type="radio"], input[type="checkbox"]';
// selecty
const SELECT = 'select';
// labely
const LABEL = 'label';
// všechny inputy
const INPUTALL = 'input, textarea, select';
// selector - kontajner ke klonování
const NODE = '.form-subsection';
// selector - klonovací tlačítko
const CLONE = '[name="btnAdd"]';
// selector - odebírací tlačítko
// při změně je nutno upravit renderer "náhradního" tlačítka !!
const REMOVE = '[name="btnRemove"]';

const addIndexes = (parent) => {

    [...parent.querySelectorAll(NODE)].forEach((node, index)=>{

        // indexovnání
        [...node.querySelectorAll(INPUTALL)].forEach(element=>{
            // atribut name;
            if (/\[\d*\]$/.test(element.getAttribute('name'))) {
                element.setAttribute('name', element.getAttribute('name').replace(/\[\d*]$/, '['+index+']'));
            } else {
                console.warn('element v klonovaném bloku nemá indexovatelné name!', element);
            }
            // atribut id
            if (element.getAttribute('id')) {
                if (/_clone_\d+$/.test(element.getAttribute('id'))) {
                    element.setAttribute(
                        'id',
                        element.getAttribute('id').replace(
                            /_clone_\d+$/,
                            index
                                ? '_clone_'+index
                                : ''
                        )
                    )
                } else {
                    element.setAttribute(
                        'id',
                        element.getAttribute('id')
                        +(index ? '_clone_'+index : '')
                    );
                }
            }
        });

        // úprava for atributu labelů
        [...node.querySelectorAll(LABEL)].forEach(element=>{
            if (element.getAttribute('for')) {
                if (/_clone_\d+$/.test(element.getAttribute('for'))) {
                    element.setAttribute(
                        'for',
                        element.getAttribute('for').replace(
                            /_clone_\d+$/,
                            index
                                ? '_clone_'+index
                                : ''
                        )
                    )
                } else {
                    element.setAttribute(
                        'for',
                        element.getAttribute('for')
                        +(index ? '_clone_'+index : '')
                    );
                }
            }
        });

    })

}

window.addEventListener('DOMContentLoaded', ()=> {

    window.addEventListener('click', (event) => {

        let target;

        // klonovač //
        if (target = event.target.closest(CLONE)) {

            let node = target.closest(NODE);
            if (node) {

                let clone = node.cloneNode({deep: true});

                // vynulovat inputy //
                clone.querySelectorAll(INPUT).forEach(e => e.value = '');
                // vynulovat selecty  //
                clone.querySelectorAll(SELECT).forEach(e => e.value=e.options[0]??'');
                // vynulovat radia/checkboxy //
                clone.querySelectorAll(CHK).forEach(e => e.checked = false);
                // neexistuje mazací tlačítko? dokreslit náhradní //
                if (!clone.querySelector(REMOVE)) {
                    clone.querySelector(CLONE).insertAdjacentHTML(
                        'afterEnd',
                        '<button type="button" class="btn-outline-danger btn"  name=btnRemove" data-remove=".form-subsection" ><span class="icon-bin2"></span><span class="btn-text">Odebrat</span></button>'
                    );
                }
                node.insertAdjacentElement('afterend', clone);

                addIndexes(node.parentNode);

                // inity kolem formu, jsou-li k dispozici //
                window.initTextareaCounter?.();

            }

            // vymazávač //
        } else if (target = event.target.closest(REMOVE)) {

            let node = target.closest(NODE);
            // nesmažu si posledního...
            if (node && ['previousElementSibling', 'nextElementSibling'].some((s) => node[s]?.matches(target.dataset.remove))) {
                let parent = node.parentNode;
                node.remove();
                addIndexes(parent);
            }

        }


    });

});

window.form2RemoveCallback = (event) => {
    let target;
    if (target = event.target.closest(event.target.closest('[data-remove]')?.dataset.remove)) {
        return (
            [...target.querySelectorAll(INPUT)].some(e=>e.value)
                ? {prompt: window.jstr?.(DIALOG)??DIALOG, head:window.jstr?.(HEAD)??HEAD}
                : true
        )

    }
}